// Device.js
import { writable } from 'svelte/store';
import { onMount } from 'svelte';

export const isMobileOrTablet = writable(false);

function checkDevice() {
	const mobileQuery = window.matchMedia('(max-width: 767px)');
	const tabletQuery = window.matchMedia('(min-width: 768px) and (max-width: 1024px)');

	isMobileOrTablet.set(mobileQuery.matches || tabletQuery.matches);
}

export function initializeDeviceCheck() {
	onMount(() => {
		checkDevice();
		window.addEventListener('resize', checkDevice);

		return () => {
			window.removeEventListener('resize', checkDevice);
		};
	});
}
